export const COLUMN_SIZE = 12
export const COLUMN_GAP = 20

export const SPLITTER_PREFIX = 'after_'
